@if (roleLocations.length > 0) {
    <dx-list class="dx-list-boxed mb-2 h-auto"
             [dataSource]="roleLocations"
             [hoverStateEnabled]="false"
             [activeStateEnabled]="false"
             [focusStateEnabled]="false"
             [allowItemDeleting]="!readonly"
             (onItemDeleted)="deleteRoleLocation($event)">
        <dxo-list-item-dragging [allowReordering]="false"></dxo-list-item-dragging>
        <div *dxTemplate="let roleLocation of 'item'">
            <adapt-link-team [teamId]="roleLocation.teamId"
                             [showIcon]="true"></adapt-link-team>
        </div>
    </dx-list>
}

@if (this.configurableTeams.length > 0 && !readonly) {
    <adapt-select-team [required]="false"
                       [filter]="teamFilter"
                       [(team)]="selectedTeam"
                       (teamChange)="onTeamSelected($event)"></adapt-select-team>
}
